import React from 'react'
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css'

function ProdLoad() {
  return (
    <>
    <div className="col-md-3 col-sm-6 col-xs-8 col-12 mb-4">
        <Skeleton height={300} />
    </div>
    <div className="col-md-3 col-sm-6 col-xs-8 col-12 mb-4">
        <Skeleton height={300} />
    </div>
    <div className="col-md-3 col-sm-6 col-xs-8 col-12 mb-4">
        <Skeleton height={300} />
    </div>
    <div className="col-md-3 col-sm-6 col-xs-8 col-12 mb-4">
        <Skeleton height={300} />
    </div>
    <div className="col-md-3 col-sm-6 col-xs-8 col-12 mb-4">
        <Skeleton height={300} />
    </div>
    <div className="col-md-3 col-sm-6 col-xs-8 col-12 mb-4">
        <Skeleton height={300} />
    </div>
    <div className="col-md-3 col-sm-6 col-xs-8 col-12 mb-4">
        <Skeleton height={300} />
    </div>
    <div className="col-md-3 col-sm-6 col-xs-8 col-12 mb-4">
        <Skeleton height={300} />
    </div>
    </>
  )
}

export default ProdLoad